import { createContext, FC, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { getUserAuthFromLocalStorage, removeUserAuthFromLocalStorage, saveUserAuthToLocalStorage } from './util/userAuthPersistUtil';

import  { AuthenticatedUser } from './type/User';

export interface ISecurityContext {
    user: AuthenticatedUser | undefined;
    verificationCodeInputVisible: boolean;
    setUser: (user: AuthenticatedUser) => void;
    setVerificationCodeInputVisible: (isVisible: boolean) => void;
    resetUserData: () => void;
}

export const SecurityContext = createContext<ISecurityContext | undefined>(undefined);

export const SecurityProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const { authenticatedUser } = getUserAuthFromLocalStorage();
    const [userState, setUserState] = useState<AuthenticatedUser | undefined>(authenticatedUser);
    const [verificationCodeInputVisible, setVerificationCodeInputVisible] = useState<boolean>(false);

    useEffect((): void => {
        if (userState) {
            saveUserAuthToLocalStorage(authenticatedUser);
        }
    }, [userState]);

    const resetUserData = useCallback((): void => {
        setUserState(undefined);
        setVerificationCodeInputVisible(false);
        removeUserAuthFromLocalStorage();
    }, []);

    const value = useMemo(() => {
        return {
            user: userState,
            verificationCodeInputVisible,
            setUser: setUserState,
            setVerificationCodeInputVisible,
            resetUserData,
        };
    }, [userState, verificationCodeInputVisible, setVerificationCodeInputVisible, resetUserData]);

    // @ts-ignore
    return <SecurityContext.Provider value={value}>{children}</SecurityContext.Provider>;
};
